document.addEventListener("DOMContentLoaded", function () {
    const accordionTriggers = document.querySelectorAll(".accordion-card-trigger");

    accordionTriggers.forEach(trigger => {
        const content = document.getElementById(trigger.getAttribute("aria-controls"));
        const innerContent = content.querySelector(".overflow-hidden"); // Seleccionamos el div interno
        const isExpanded = trigger.getAttribute("aria-expanded") === "true";

        // Si el acordeón está expandido al inicio (según el HTML), le damos su altura
        if (isExpanded) {
            content.style.maxHeight = innerContent.scrollHeight + "px";
        } else {
            content.style.maxHeight = "0px";
        }

        trigger.addEventListener("click", function () {
            const isExpandedNow = this.getAttribute("aria-expanded") === "true";

            // Cierra todos los demás acordeones
            document.querySelectorAll(".accordion-card-trigger").forEach(otherTrigger => {
                if (otherTrigger !== this) {
                    otherTrigger.setAttribute("aria-expanded", "false");
                    const otherContent = document.getElementById(otherTrigger.getAttribute("aria-controls"));
                    otherContent.style.maxHeight = "0px";
                }
            });

            // Alternar el acordeón actual
            if (isExpandedNow) {
                this.setAttribute("aria-expanded", "false");
                content.style.maxHeight = "0px";
            } else {
                this.setAttribute("aria-expanded", "true");
                content.style.maxHeight = innerContent.scrollHeight + "px";
            }
        });
    });
});
